/**
 * Parcours atelier — étapes affichées (stepper) et transitions « Étape suivante ».
 * Mapping métier par défaut ; à affiner avec le métier si besoin.
 */

export const WORKSHOP_STEPS = [
  {
    key: 'reception',
    label: 'Réception',
    matchStatuses: ['pending', 'on_hold'],
    hint: 'Réceptionner le dossier physique et lancer la production.',
  },
  {
    key: 'production',
    label: 'Production',
    matchStatuses: ['printing', 'post_processing', 'in_progress', 'delayed'],
    hint: 'Réaliser les étapes de fabrication du lot.',
  },
  {
    key: 'quality',
    label: 'Contrôle',
    matchStatuses: ['quality_check'],
    hint: 'Contrôler la qualité du lot avant emballage.',
  },
  {
    key: 'packaging',
    label: 'Emballage',
    matchStatuses: ['packaging'],
    hint: 'Emballer le lot pour la suite du circuit.',
  },
  {
    key: 'done',
    label: 'Terminé',
    matchStatuses: ['completed', 'cancelled'],
    hint: 'Lot terminé.',
  },
];

export function workshopStepKeyForStatus(status) {
  for (let i = 0; i < WORKSHOP_STEPS.length; i++) {
    if (WORKSHOP_STEPS[i].matchStatuses.includes(status)) return WORKSHOP_STEPS[i].key;
  }
  return 'production';
}

export function workshopStepIndexForKey(stepKey) {
  return WORKSHOP_STEPS.findIndex((s) => s.key === stepKey);
}

/**
 * Prochain statut technique à enregistrer en base (tolère les variantes hors enum locale).
 */
const NEXT_STATUS = {
  pending: 'in_progress',
  on_hold: 'in_progress',
  printing: 'post_processing',
  post_processing: 'in_progress',
  in_progress: 'quality_check',
  delayed: 'in_progress',
  quality_check: 'packaging',
  packaging: 'completed',
};

export function getNextWorkshopStatus(currentStatus) {
  if (currentStatus === 'completed' || currentStatus === 'cancelled') return null;
  return NEXT_STATUS[currentStatus] ?? null;
}

export function isWorkshopTerminal(status) {
  return status === 'completed' || status === 'cancelled';
}

export function workshopStepHintForStatus(status) {
  const key = workshopStepKeyForStatus(status);
  const step = WORKSHOP_STEPS.find((s) => s.key === key);
  return step?.hint || 'Poursuivre le lot.';
}
